"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ACTIVE: 'active',
    DISABLED: 'disabled',
};
//# sourceMappingURL=tutorSubjectStatus.js.map